import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { withApollo } from 'react-apollo';
import { Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';
import { parseFormErrors } from '../shared/utils/form_errors';
import RaffleForm from './components/RaffleForm';
import { CreateRaffleMutation } from './queries';


class NewRaffle extends Component {
  handleSubmit = (data) => {
    const { client, push } = this.props;
    return client.mutate({ mutation: CreateRaffleMutation, variables: { record: data } })
    .then(() => push('/raffles'))
    .catch(parseFormErrors);
  }

  render() {
    return (
      <div>
        <Breadcrumb>
          <Breadcrumb.Item><Link to="/raffles">Raffles</Link></Breadcrumb.Item>
          <Breadcrumb.Item>New Raffle</Breadcrumb.Item>
        </Breadcrumb>

        <div className="container">
          <RaffleForm
            onSubmit={this.handleSubmit}
          />
        </div>
      </div>
    );
  }
}
export default compose(
  connect(null, { push }),
  withApollo,
)(NewRaffle);
